/**
 * PaywallErrorView - Error state display after payment failure
 *
 * Shows decline message and allows user to retry with different card.
 */

interface PaywallErrorViewProps {
  errorMessage: string;
  onRetry: () => void;
}

export function PaywallErrorView({ errorMessage, onRetry }: PaywallErrorViewProps) {
  return (
    <div className="flex w-full flex-col items-center gap-4 rounded-xl border border-red-200 bg-red-50 p-6 text-center">
      {/* Error icon */}
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
        <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>

      {/* Error message */}
      <div className="flex flex-col gap-1">
        <p className="text-base font-medium text-red-800">{errorMessage}</p>
        <p className="text-sm text-red-600">Please try a different payment method.</p>
      </div>

      {/* Retry button */}
      <button
        onClick={onRetry}
        className="mt-2 rounded-lg border border-red-300 bg-white px-4 py-2 text-sm font-medium text-red-700 transition-colors hover:bg-red-50"
      >
        Try Again
      </button>
    </div>
  );
}
